module.exports = __webpack_public_path__ + "static/media/b5ad4d36b724bf3aa48e5f6bbec634ad.b5ad4d36.webp";